<template>
  <div id="app">
    <router-view></router-view>
    <!-- 登录后全局挂载方案生态对话：否则仅在 /schemeEcosystem 子布局内才有 WS，停留在 /home 等页面时收不到实时推送 -->
    <DialogueCenter
      v-if="hasLoginToken && !hideGlobalDialogue"
      :embedded="true"
      :show-float="true"
      :reset-float-on-mount="false"
    />
    <!-- 注册云企业 -->
    <CloudAuthPopup />
    <!-- 工单下单 -->
    <WorkOrderPlacePopup />
    <!-- 登录弹窗 -->
    <LoginPopup />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CloudAuthPopup from '@/components/Popup/CloudEnterpriseAuth.vue'
import WorkOrderPlacePopup from '@/components/Popup/WorkOrderPlace.vue'
import LoginPopup from '@/components/LoginPopup/index.vue'
import DialogueCenter from '@/views/DialogueCenter.vue'

export default {
  name: 'App',
  components: {
    CloudAuthPopup,
    WorkOrderPlacePopup,
    LoginPopup,
    DialogueCenter
  },
  computed: {
    ...mapGetters(['token']),
    hasLoginToken() {
      return !!(this.token && String(this.token).trim())
    },
    hideGlobalDialogue() {
      return (this.$route.matched || []).some((record) => record.meta && record.meta.hideGlobalDialogue)
    }
  }
}
</script>

<style lang="less">
</style>
